import { getIdToken, signOut } from './auth';
const API_BASE = process.env.REACT_APP_API_BASE;

export async function apiGet(path) {
	const url = `${API_BASE}${path}`;
	const token = getIdToken();

	// console.log('[apiGet] Request:', {
	// 	url,
	// 	hasToken: !!token,
	// 	tokenLength: token?.length || 0,
	// 	origin: window.location.origin,
	// 	protocol: window.location.protocol,
	// });

	try {
		const res = await fetch(url, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			credentials: 'omit',
			mode: 'cors', // Explicitly set CORS mode
		});

		// console.log('[apiGet] Response:', {
		// 	status: res.status,
		// 	statusText: res.statusText,
		// 	ok: res.ok,
		// 	headers: Object.fromEntries(res.headers.entries()),
		// });

		// Handle 401 - clear tokens and throw specific error
		if (res.status === 401) {
			// console.error('[apiGet] Unauthorized - clearing tokens');
			signOut();
			throw new Error('UNAUTHORIZED');
		}

		if (!res.ok) {
			// console.error('[apiGet] HTTP error:', res.status, res.statusText);
			throw new Error(`HTTP ${res.status}`);
		}

		const data = await res.json();
		// console.log('[apiGet] Success:', data);
		return data;
	} catch (error) {
		// console.error('[apiGet] Fetch error:', {
		// 	name: error.name,
		// 	message: error.message,
		// 	stack: error.stack,
		// 	errorType: error.constructor.name,
		// });

		// Enhanced error diagnostics
		const diagnostics = {
			url,
			origin: window.location.origin,
			protocol: window.location.protocol,
			errorName: error.name,
			errorMessage: error.message,
			isPossibleCORS: error.name === 'TypeError' && error.message.includes('Failed to fetch'),
			isPossibleNetwork: error.message.includes('Load failed') || error.message.includes('NetworkError'),
		};
		// console.error('[apiGet] Diagnostics:', diagnostics);

		// Re-throw with more context
		if (error.message === 'UNAUTHORIZED') throw error;
		if (error.message.startsWith('HTTP')) throw error;

		// Network or parsing error - provide detailed message
		if (diagnostics.isPossibleCORS) {
			throw new Error(`Network error: ${error.message} (Possible CORS issue - check API allows origin: ${window.location.origin})`);
		}

		throw new Error(`Network error: ${error.message}`);
	}
}

export async function apiPost(path, body) {
	const token = localStorage.getItem('idToken');
	const url = `${API_BASE}${path}`;

	// console.log('[apiPost] Request:', {
	// 	url,
	// 	hasToken: !!token,
	// 	tokenLength: token?.length || 0,
	// 	origin: window.location.origin,
	// 	protocol: window.location.protocol,
	// 	body,
	// });

	try {
		const resp = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: token ? `Bearer ${token}` : '',
			},
			body: JSON.stringify(body),
			credentials: 'omit',
			mode: 'cors', // Explicitly set CORS mode
		});

		// console.log('[apiPost] Response:', {
		// 	status: resp.status,
		// 	statusText: resp.statusText,
		// 	ok: resp.ok,
		// 	headers: Object.fromEntries(resp.headers.entries()),
		// });

		// Handle 401 - clear tokens and throw specific error
		if (resp.status === 401) {
			// console.error('[apiPost] Unauthorized - clearing tokens');
			signOut();
			throw new Error('UNAUTHORIZED');
		}

		if (!resp.ok) {
			// console.error('[apiPost] HTTP error:', resp.status, resp.statusText);
			throw new Error(`API error ${resp.status}`);
		}

		const data = await resp.json();
		// console.log('[apiPost] Success:', data);
		return data;
	} catch (error) {
		// console.error('[apiPost] Fetch error:', {
		// 	name: error.name,
		// 	message: error.message,
		// 	stack: error.stack,
		// 	errorType: error.constructor.name,
		// });

		// Enhanced error diagnostics
		const diagnostics = {
			url,
			origin: window.location.origin,
			protocol: window.location.protocol,
			errorName: error.name,
			errorMessage: error.message,
			isPossibleCORS: error.name === 'TypeError' && error.message.includes('Failed to fetch'),
			isPossibleNetwork: error.message.includes('Load failed') || error.message.includes('NetworkError'),
		};
		// console.error('[apiPost] Diagnostics:', diagnostics);

		// Re-throw with more context
		if (error.message === 'UNAUTHORIZED') throw error;
		if (error.message.startsWith('API error')) throw error;

		// Network or parsing error - provide detailed message
		if (diagnostics.isPossibleCORS) {
			throw new Error(`Network error: ${error.message} (Possible CORS issue - check API allows origin: ${window.location.origin})`);
		}

		throw new Error(`Network error: ${error.message}`);
	}
}
